/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosInstance';
import { appSliceActions } from '../../appSlices/appSlice';

export const VstAdaptorWrapper = ({ children }) => {
  const [adaptorType, setAdaptorType] = useState('uninitialized');
  // eslint-disable-next-line no-unused-vars
  const [adaptorVersion, setAdaptorVersion] = useState('uninitialized');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    axiosInstance
      .get(`${window.location.protocol}//${window.location.host}/api/v1/sensor/version`)
      .then((response) => {
        if (response.data) {
          setAdaptorType(response.data.type);
          setAdaptorVersion(response.data.version);
          dispatch(appSliceActions.setAdaptorType(response.data.type));
          dispatch(appSliceActions.setAdaptorVersion(response.data.version));
        }
      })
      .catch((error) => {
        console.log('failed to fetch VST version', error);
        setAdaptorType('NA');
        setAdaptorVersion('NA');
        dispatch(appSliceActions.setAdaptorType('NA'));
        dispatch(appSliceActions.setAdaptorVersion('NA'));
        if (error.response.status === 401 && error.response.data.error_code === 'ClientUnauthorizedError') {
          navigate('/login', { replace: true });
        }
      });
  }, [dispatch, navigate]);

  return (
    <Box>
      {/* {
				adaptorType === "error" && <>show dialog to select adaptor</>
			} */}
      {adaptorType !== 'uninitialized' && <>{children}</>}
    </Box>
  );
};
